export default __webpack_public_path__ + "static/media/logo-mobile.8d1aa333.svg";